// src/components/AGTUps/Subscription/SubscriptionSuccess.js
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { Check } from 'lucide-react';
import subscriptionService from '../services/AGTUps-product-services/subscription-service';

const SubscriptionSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
  const [message, setMessage] = useState('Verifying your subscription...');

  useEffect(() => {
    const verifySubscription = async () => {
      const sessionId = searchParams.get('session_id');

      if (!sessionId) {
        setStatus('error');
        setMessage('Invalid session ID');
        setTimeout(() => navigate('/'), 3000);
        return;
      }

      try {
        // Verificar la sesión con el backend
        const response = await subscriptionService.verifyCheckoutSession(sessionId);

        if (response.success) {
          setStatus('success');
          setMessage('Subscription activated successfully!');

          // Redirigir al dashboard después de 2 segundos
          setTimeout(() => {
            navigate('/', { replace: true });
          }, 2000);
        } else {
          setStatus('error');
          setMessage('Failed to verify subscription');
          setTimeout(() => navigate('/'), 3000);
        }
      } catch (error) {
        console.error('Error verifying subscription:', error);
        setStatus('error');
        setMessage('An error occurred while verifying your subscription');
        setTimeout(() => navigate('/'), 3000);
      }
    };

    verifySubscription();
  }, [searchParams, navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        textAlign: 'center',
        p: 3
      }}
    >
      {status === 'verifying' && (
        <>
          <CircularProgress size={60} sx={{ mb: 3 }} />
          <Typography variant="h5" gutterBottom>
            {message}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Please wait while we confirm your payment...
          </Typography>
        </>
      )}

      {status === 'success' && (
        <>
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: '50%',
              backgroundColor: 'success.main',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 3,
              animation: 'scaleIn 0.5s ease-out',
              '@keyframes scaleIn': {
                '0%': {
                  transform: 'scale(0)',
                  opacity: 0
                },
                '100%': {
                  transform: 'scale(1)',
                  opacity: 1
                }
              }
            }}
          >
            <Check size={48} color="white" />
          </Box>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>
            {message}
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
            Thank you for subscribing to AGTUps Pro!
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Redirecting you to the dashboard...
          </Typography>
        </>
      )}

      {status === 'error' && (
        <>
          <Typography variant="h5" color="error" gutterBottom>
            {message}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Redirecting you back...
          </Typography>
        </>
      )}
    </Box>
  );
};

export default SubscriptionSuccess;
